import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'age',
    standalone: false
})
export class AgePipe implements PipeTransform {

  transform(value: any): number {

    const year = new DatePipe('en-GB').transform(value,'yyyy');
    const month = new DatePipe('en-GB').transform(value,'MM');
    const day = new DatePipe('en-GB').transform(value,'dd');

    const dob = new Date().setFullYear(Number(year), Number(month) ,Number(day));

    const timeDiff = Math.abs(Date.now() - dob);
    return Math.floor((timeDiff / (1000 * 3600 * 24))/365);

  }
}
